export const validation = {
  titleMaxChar: 50,
  subTitleMaxChar: 80,
  paragraphMaxChar: 300,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}